import React, { useState } from "react";
import { Alert, Box, Tab, Tabs, Typography } from "@mui/material";
import ServicesStatusTab from "./ServicesStatusTab";
import UsageStatusTab from "./UsageStatusTab";

const StatusPage = ({ publicView = false }) => {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ maxWidth: 1400, mx: "auto", py: 1 }}>
      <Box sx={{ px: { xs: 2, md: 3 }, mb: 1.5, display: "flex", alignItems: { xs: "stretch", md: "flex-end" }, justifyContent: "space-between", flexDirection: { xs: "column", md: "row" }, gap: 1 }}>
        <Box>
          <Typography component="h1" sx={{ fontSize: { xs: "1.75rem", md: "2rem" }, fontWeight: 800, color: "#202531", lineHeight: 1.2 }}>
            Status
          </Typography>
          <Typography variant="body2" sx={{ color: "#6b7280", mt: 0.5 }}>
            Monitor service health and processing usage.
          </Typography>
        </Box>
        <Tabs value={tab} onChange={(_, value) => setTab(value)} aria-label="Status dashboards"
          sx={{ borderBottom: "1px solid #e5e7eb", "& .MuiTabs-indicator": { backgroundColor: "#f97316" }, "& .Mui-selected": { color: "#ea580c !important" } }}>
          <Tab id="status-tab-service" aria-controls="status-panel-service" label="Service status" sx={{ textTransform: "none", fontWeight: 700 }} />
          <Tab id="status-tab-usage" aria-controls="status-panel-usage" label="Usage Status" sx={{ textTransform: "none", fontWeight: 700 }} />
        </Tabs>
      </Box>
      <Box role="tabpanel" id="status-panel-service" aria-labelledby="status-tab-service" hidden={tab !== 0}>
        {tab === 0 && <ServicesStatusTab />}
      </Box>
      <Box role="tabpanel" id="status-panel-usage" aria-labelledby="status-tab-usage" hidden={tab !== 1}>
        {tab === 1 && (publicView ? (
          <Alert severity="info" sx={{ mx: { xs: 2, md: 4 } }}>
            Sign in to the dashboard with a System Admin or Customer Success account to view Usage Status.
          </Alert>
        ) : <UsageStatusTab />)}
      </Box>
    </Box>
  );
};

export default StatusPage;
